<template>
  <div class="obras-page">
    <div class="container">

      <!-- Los Descreídos -->
      <article class="obra" id="los-descreidos">
        <div class="obra-header">
          <h2 class="obra-title">Los Descreídos</h2>
          <div class="obra-awards">
            <span class="award">🏆 Mejor Espectáculo - Florencio 2017</span>
            <span class="award">🏆 Mejor Dirección - Florencio 2017</span>
            <span class="award">🏆 Mejor Actor - Florencio 2017</span>
          </div>
        </div>

        <div class="obra-gallery">
          <img src="/images/obras/descreidos_1.jpg" alt="Los Descreídos" class="obra-img">
          <img src="/images/obras/descreidos_2.jpg" alt="Los Descreídos" class="obra-img">
        </div>

        <div class="obra-content">
          <p>La Ciudad de la Costa, siendo segunda en cantidad de habitantes del país, siempre ha sido un foco sumamente receptivo a propuestas artísticas. El estreno de <strong>Los Descreídos</strong> en enero del 2015 y sus posteriores temporadas lo han reafirmado cada verano.</p>

          <p>Los Descreídos es un espectáculo inspirado en el folklore mágico del Uruguay, siendo éste el pretexto para encontrarse en un espacio único: <em>un fogón entre las dunas de Médanos de Solymar</em>. Cuenteros, trovadores modernos, nos acercan a esas expresiones tan arraigadas de nuestro arte popular.</p>

          <p>Esta obra pretende rescatar la riqueza literaria de los mitos, sus enseñanzas, su temperamento; ya que preservar aquello que nos diferencia como cultura, enriquece el patrimonio de toda la humanidad.</p>
        </div>
      </article>

      <!-- Divider -->
      <div class="obra-divider"></div>

      <!-- El Circo Olvidado -->
      <article class="obra" id="el-circo-olvidado">
        <div class="obra-header">
          <h2 class="obra-title">El Circo Olvidado</h2>
          <div class="obra-awards">
            <span class="award">🏆 Mejor Espectáculo - Florencio 2019</span>
            <span class="award">🏆 Mejor Dirección - Florencio 2019</span>
          </div>
        </div>

        <div class="obra-gallery">
          <img src="/images/obras/circo_1.jpg" alt="El Circo Olvidado" class="obra-img">
          <img src="/images/obras/circo_2.jpg" alt="El Circo Olvidado" class="obra-img">
        </div>

        <div class="obra-content">
          <h3 class="content-subtitle">La propuesta</h3>
          <p>Inspirada en el circo criollo, expresión única y original del Río de la Plata, la obra pretende recrear, en clave actual, la forma artística de aquel circo de antaño que supo combinar y sintetizarse con el teatro, dando lugar a un circo con argumento.</p>

          <p><strong>El Circo Olvidado</strong> centra su historia en "los olvidados", excluidos del sistema, marginados que se expresarán a través del humor, la fantasía y la magia circense.</p>

          <h3 class="content-subtitle">Los espacios</h3>
          <p>En primera instancia, el espectáculo se concibe para presentarse en espacios abiertos. Terminaría haciéndolo entre los médanos de las costas uruguayas (al igual que Los Descreídos), pero los parques y plazas públicas siempre se manejaron como opción.</p>

          <p>No obstante, el grupo también mantuvo la idea de llevar el espectáculo a salas más tradicionales. Luego de realizar varias funciones en teatros como <em>Sala Verdi</em> y el <em>Florencio Sánchez</em> de Montevideo, se pudo comprobar la adaptabilidad del espectáculo en el recibimiento y respuesta de la gente.</p>

          <p>Su estructura en episodios permitió diversas variantes de pequeño, mediano y gran formato que, a pesar de las dificultades técnicas, logró mantener la esencia del espacio participativo en cada lugar, generando una interacción de ida y vuelta con los espectadores.</p>

          <h3 class="content-subtitle">El porqué</h3>
          <p>Nuestro interés como grupo de teatro siempre ha sido el de preservar nuestra riqueza cultural histórica. Entendemos la defensa de nuestro patrimonio cultural como una apuesta al futuro, a la convicción de que estas características peculiares nos otorgan un espacio para el diálogo y comprensión intercultural.</p>

          <p>El Circo Olvidado es un proyecto basado en estas raíces, y nos permite desempolvar un viejo recurso para redescubrirnos íntegramente como sociedad al día de hoy.</p>
        </div>
      </article>

    </div>
  </div>
</template>

<script>
export default {
  name: 'ObrasPage',
  mounted() {
    this.$nextTick(() => {
      const hash = this.$route.hash;
      if (hash) {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        window.scrollTo(0, 0);
      }
    });
  },
  watch: {
    '$route.hash'(newHash) {
      if (newHash) {
        const el = document.querySelector(newHash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  }
}
</script>

<style scoped>
.obras-page {
  background: #000;
  padding: 60px 0 80px;
  min-height: 50vh;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Obra Article */
.obra {
  margin-bottom: 60px;
}

.obra-header {
  text-align: center;
  margin-bottom: 35px;
}

.obra-title {
  font-size: 42px;
  font-weight: bold;
  color: #c9a227;
  margin: 0 0 15px 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.obra-subtitle {
  display: block;
  font-size: 18px;
  color: #888;
  font-style: italic;
}

/* Awards */
.obra-awards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
}

.award {
  background: rgba(201, 162, 39, 0.15);
  border: 1px solid #c9a227;
  color: #c9a227;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 15px;
  border-radius: 20px;
}

/* Gallery */
.obra-gallery {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 35px;
}

.obra-img {
  width: 100%;
  height: 280px;
  object-fit: cover;
  border-radius: 10px;
  border: 1px solid #333;
  transition: all 0.3s ease;
}

.obra-img:hover {
  border-color: #c9a227;
  transform: scale(1.02);
}

/* Content */
.obra-content {
  color: #ddd;
}

.obra-content p {
  font-size: 18px;
  line-height: 1.8;
  margin: 0 0 20px 0;
  text-align: justify;
}

.obra-content p:last-child {
  margin-bottom: 0;
}

.obra-content strong {
  color: #c9a227;
}

.obra-content em {
  color: #fff;
  font-style: italic;
}

.content-subtitle {
  font-size: 22px;
  font-weight: bold;
  color: #fff;
  margin: 35px 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #333;
}

.content-subtitle:first-of-type {
  margin-top: 0;
}

/* Divider */
.obra-divider {
  height: 1px;
  background: linear-gradient(to right, transparent, #c9a227, transparent);
  margin: 60px 0;
}

/* Mobile */
@media (max-width: 767px) {
  .obras-page {
    padding: 40px 0 60px;
  }

  .obra-title {
    font-size: 28px;
  }

  .obra-awards {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .award {
    font-size: 12px;
    padding: 6px 12px;
  }

  .obra-gallery {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .obra-img {
    height: 220px;
  }

  .obra-content p {
    font-size: 16px;
    line-height: 1.7;
    text-align: left;
  }

  .content-subtitle {
    font-size: 18px;
  }

  .obra-divider {
    margin: 40px 0;
  }
}
</style>